import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeSix from '../views/HomeSix.vue'
import AIConsult from '../views/AIConsult.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeSix',
    component: HomeSix
  },
  {
    path: '/ai-consult',
    name: 'AIConsult',
    component: AIConsult
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  // 페이지 이동 시 스크롤 최상단으로
  scrollBehavior() {
    const el = document.getElementById('app');
    if (el) {
      el.scrollIntoView();
    }
    return { x: 0, y: 0 };
  }
})

export default router
